/**
 * Convert ISO date string to yyyy-MM-dd format for HTML date input
 * @param {string} isoDate - ISO date string (e.g., "1982-01-06T00:00:00.000Z")
 * @returns {string} - Formatted date (e.g., "1982-01-06")
 */
export const formatDateForInput = (isoDate) => {
  if (!isoDate) return '';
  
  try {
    // If already in yyyy-MM-dd format, return as-is
    if (/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) return isoDate;
    
    // Convert ISO to yyyy-MM-dd
    const date = new Date(isoDate);
    
    // Check if date is valid
    if (isNaN(date.getTime())) return '';
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

/**
 * Convert yyyy-MM-dd to ISO date string
 * @param {string} dateString - Date string (e.g., "1982-01-06")
 * @returns {string} - ISO date string
 */
export const formatDateForAPI = (dateString) => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    return date.toISOString();
  } catch (error) {
    console.error('Error converting to ISO:', error);
    return dateString; // Return as-is if conversion fails
  }
};